export default "__VITE_ASSET__BdnY$__s__"